// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Check } from 'lucide-react';

import { Text } from 'reshaped';

import styles from './PlanContent.scss';

export type Options = Array<{
  id: string,
  content?: React.Node,
  detail?: React.Node,
  component?: React.Node,
}>;

type Props = {
  cta?: React.Node,
  detail?: React.Node,
  durationWording?: string,
  options?: Options,
  price?: React.Node,
  priceCrossOut?: string,
  sizeLabel: React.Node,
};

export function PlanContent({
  cta,
  detail,
  durationWording,
  options,
  price,
  priceCrossOut,
  sizeLabel,
}: Props): React.MixedElement {
  return (
    <>
      <div className={styles.titleContainer}>
        <span>{sizeLabel}</span>
        {!!price && (
          <div className={styles.priceContainer}>
            <div>
              <span className={styles.price}>
                {priceCrossOut && <del>{priceCrossOut}</del>} {price}
              </span>
              /{durationWording}
            </div>
            {detail ? <div className={styles.detail}>{detail}</div> : null}
          </div>
        )}
      </div>
      <ul className={styles.options}>
        {options?.map(option => {
          if (option) {
            if (option.content) {
              return (
                <li key={option.id}>
                  <Check size={16} />
                  <span>
                    {option.content}
                    {!!option.detail && (
                      <>
                        {' '}
                        <Text color="neutral-faded" wrap="balance" as="span">
                          – {option.detail}
                        </Text>
                      </>
                    )}
                  </span>
                </li>
              );
            }
            if (option.component) {
              return (
                <React.Fragment key={option.id}>
                  {option.component}
                </React.Fragment>
              );
            }
            return null;
          }
          return null;
        })}
      </ul>
      {cta}
    </>
  );
}

type PropsPlanDisplay = {
  ...Props,
  className?: string,
  disabled?: boolean,
  isSelected?: boolean,
};

// To use without form
export const PlanDisplay = ({
  className,
  cta,
  isSelected,
  sizeLabel,
  price,
  priceCrossOut,
  detail,
  options,
  disabled,
  durationWording,
}: PropsPlanDisplay): React.MixedElement => (
  <div
    className={clsx(
      styles.root,
      disabled ? styles.disabled : undefined,
      isSelected ? styles.isSelected : undefined,
      className,
    )}
  >
    <PlanContent
      sizeLabel={sizeLabel}
      price={price}
      priceCrossOut={priceCrossOut}
      detail={detail}
      options={options}
      cta={cta}
      durationWording={durationWording}
    />
  </div>
);
